import type { ColumnDef } from '@tanstack/react-table'
import type { FleetReportExpense } from '../../../../../types'
import { ReportColumnHeader } from '../ReportColumnHeader'
import { fetchInvoiceDocument, fetchInvoiceDocumentAttachments } from '../../../../../api/api'
import Pdf from '../../../../../icons/Pdf'
import LinkButton from '../../../../../components/LinkButton'
import { formatNumber } from '../../utils/formatNumber'
import { formatDate } from '../../../../cars/components/V3/helpers/formatDate'

const settings = { digits: { min: 0, max: 0 }, prefix: 'kr ' }

export const fleetReportExpenseColumns: ColumnDef<FleetReportExpense>[] = [
  {
    accessorKey: 'kostnadsart',
    header: () => <ReportColumnHeader title="Kostnadsart" />,
    cell: ({ getValue }) => getValue() || '',
    enableSorting: false,
  },
  {
    accessorKey: 'description',
    header: () => <ReportColumnHeader title="Detaljert beskrivelse" />,
    enableSorting: false,
    cell: ({ row, getValue }) => {
      const { sourceID, sourceType = -1 } = row.original
      if (!sourceID) return getValue() || ''

      switch (sourceType) {
        case 0: {
          return (
            <LinkButton
              onClick={() => fetchInvoiceDocument(sourceID, `${row.original.documentNo}-${row.original.lineNo}`)}
              className="inline-flex items-center gap-1"
            >
              <Pdf />
              {getValue()}
            </LinkButton>
          )
        }
        case 2: {
          return (
            <LinkButton
              onClick={() =>
                fetchInvoiceDocumentAttachments(sourceID, `${row.original.documentNo}-${row.original.lineNo}`)
              }
              className="inline-flex items-center gap-1"
            >
              <Pdf />
              {getValue()}
            </LinkButton>
          )
        }

        default:
          return getValue() || ''
      }
    },
  },
  {
    accessorKey: 'documentNo',
    header: () => <ReportColumnHeader title="Dokumentnr" />,
    cell: ({ getValue }) => getValue() || '',
    enableSorting: false,
  },
  {
    accessorKey: 'documentType',
    header: () => <ReportColumnHeader title="Dokument type" />,
    enableSorting: false,
    cell: ({ getValue }) => getValue() || '',
  },
  {
    accessorKey: 'termDate',
    header: () => <ReportColumnHeader title="Terminsdato" />,
    cell: ({ getValue }) => formatDate(getValue() as string) || '',
  },
  {
    accessorKey: 'amountIncludingVAT',
    header: () => <ReportColumnHeader title="Beløp ink mva" />,
    cell: ({ getValue }) => formatNumber(getValue() as number, settings),
    footer: ({ table }) => {
      const total = table
        .getFilteredRowModel()
        .rows.reduce((sum, row) => sum + (row.original.amountIncludingVAT || 0), 0)
      return <span className="font-semibold">{formatNumber(total, settings)}</span>
    },
  },
]
